import React from "react";
import { Link } from "react-router-dom";

const ICON_URL = "/asicmod-a.png";

export const Logo = ({ className = "", iconSize = 42 }) => (
  <Link to="/" className={`group flex items-center gap-3 ${className}`} data-testid="brand-logo">
    <img
      src={ICON_URL}
      alt="AsicMod"
      style={{ height: iconSize }}
      className="logo-spin w-auto object-contain"
    />
    <span className="font-heading text-2xl font-semibold tracking-tight text-[#FAFAFA]">
      Asic<span className="text-primary">Mod</span>
    </span>
  </Link>
);
